import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ErrorPage from './components/pages/error';
import AboutUs from './components/pages/about';
import ServicePage from './components/pages/services/service';
import Testimonial from './components/pages/testimonial';
import PortfolioFilterPage from './components/pages/portfolio/gallery';
import { useEffect } from 'react';
import ScrollToTop from './components/pages/common/scroll/scroll-to-top';
import { animationCreate } from '.';
import CustomCursor from './components/pages/common/cursor';
import HomeFour from './components/pages/homes/home-4';
import ContactUs from './components/pages/contacts';
import ServicesDetails from './components/pages/services/service-single';
import PortfolioDetails from './components/pages/portfolio/portfolio-details';
import BlogDetails from './components/pages/blogs/blog-details';

function App() {
    useEffect(() => {
        setTimeout(() => {
            animationCreate();
        }, 500);
    }, []);
    return (
        <>
            <CustomCursor />
            <Router><Routes>
                <Route path="/" element={<HomeFour />} />
                <Route path="/about-us" element={<AboutUs />} />
                <Route path="/services" element={<ServicePage />} />
                <Route path="/services/:id" element={<ServicesDetails />} />
                <Route path="/testimonial" element={<Testimonial />} />
                <Route path="/gallery" element={<PortfolioFilterPage />} />
                <Route path="/portfolio/:id" element={<PortfolioDetails />} />
                <Route path="/blog/:id" element={<BlogDetails />} />
                <Route path="/contact-us" element={<ContactUs />} />
                <Route path="*" element={<ErrorPage />} />
            </Routes></Router>
            <ScrollToTop />
        </>
    )
}

export default App;
